import { ButtonEdit, ButtonDetail, ButtonDelete } from "../../common/Button"
import { getRegTypeBadge, getValidObjBadge, formatDate } from "../../common/BaseUtil"

export function TalentCardMypage(props) {
    return (
        <div className="card my-3 shadow-sm" key={props.index} style={{ fontFamily: 'Nanum Gothic' }}>
            <div className="card-body">
                {/* 상단: 상태 뱃지와 날짜 */}
                <div className="d-flex justify-content-between align-items-start mb-2">
                    <div className="d-flex gap-2">
                         {/* 상태 뱃지가 있다면 추가 */}
                        {getRegTypeBadge(props.object.regType)}
                        {/* {getStatusBadge(status)} // 예시: 승인완료/대기 등 */}
                    </div>
                    <small className="text-muted" style={{ fontSize: '0.85rem' }}>
                        최종 수정: {formatDate(props.object.updateAt)}
                    </small>
                </div>
                {/* 헤더 영역: 제목과 카테고리 */}
                <div className="mb-3">
                    <h4 className="card-title fw-bold mb-3">{props.object.title}</h4>
                    <h6 className="text-muted card-subtitle">{props.object.categoryName}</h6>
                </div>

                {/* 뱃지 영역: 정보를 한 줄에 깔끔하게 표시 */}
                <div className="d-flex align-items-center mb-4">
                    {/* 왼쪽 영역: 뱃지들을 그룹화하여 왼쪽으로 배치 */}
                    <div className="d-flex gap-2">
                        {/* {getRegTypeBadge(props.object.regType)} */}
                        {getValidObjBadge(props.object.validObj)}
                    </div>

                    {/* 오른쪽 영역: ms-auto를 사용하여 나머지 공간을 채우고 오른쪽 끝으로 밀어냄 */}
                    <div className="ms-auto text-muted small">
                        <i className="bi bi-eye me-1"></i> 조회 {props.object.hits || 0}
                    </div>
                </div>

                {/* 버튼 영역: 작업 목적에 따른 그룹화 및 간격 조정 */}
                <div className="d-flex flex-wrap gap-2 pt-2 border-top">
                    <ButtonDetail
                        id={props.object.registrationId}
                        url="/talent_mypage/"
                        returnTo={props.returnTo}
                        className="btn-primary"
                    />

                    <div className="ms-auto d-flex gap-2">
                        <ButtonEdit
                            id={props.object.registrationId}
                            url="/talent_edit_mypage/"
                            className="btn-outline-secondary"
                        />
                        <ButtonDelete
                            id={props.object.id}
                            objTitle={props.object.title}
                            url="/delete/talent"
                            className="btn-outline-danger"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}